import api from "@/store/api";
import {publicPath} from "@/main";

const emptyState = () => {
    return {
        slides: [],
        salesPerson: null,
        loading: false,
        loadingContact: false,
    }
}

export default {
    namespaced: true,
    state: emptyState(),
    getters: {},
    actions: {
        slider(store: any) {
            store.commit('setLoading', true);
            api.get('content/slider').then(data => {
                store.commit('setSlides', data.data);
                store.commit('setLoading', false);
            }).catch(error => {
                store.commit('setSlides', []);
            });
        },
        salesPerson(store: any) {
            store.commit('setLoadingContact', true);
            api.get('content/sales-person').then(data => {
                store.commit('setLoadingContact', false);
                store.commit('setSalesPerson', {...data.data, globalContact: false});
            }).catch(error => {
                store.commit('setSalesPerson', {
                    globalContact: true,
                    fullName: 'Sympatia Financie',
                    email: 'info@sympatia.sk',
                    phone: '+421 2 3263 0700',
                    image: publicPath + 'images/logo-small.svg',
                });
            });
        },
    },
    mutations: {
        setSlides(state: any, data: any) {
            state.slides = data;
        },
        setSalesPerson(state: any, data: any) {
            state.salesPerson = data;
        },
        setLoading(state: any, loading: boolean = false) {
            state.loading = loading;
        },
        setLoadingContact(state: any, loading: boolean = false) {
            state.loadingContact = loading;
        },
        reset (state: any) {
            Object.assign(state, emptyState());
        }
    }
};
